
import { Component, h, State, Element, Prop, Watch } from '@stencil/core';
import { ColDef, GridOptions, GridApi, createGrid, RowDataTransaction, } from 'ag-grid-community';
import { ModuleRegistry, AllCommunityModule } from 'ag-grid-community';
    
    ModuleRegistry.registerModules([ AllCommunityModule ]);


@Component({
  tag: 'ag-grid-table',
  styleUrl: 'ag-grid-table.css',
  shadow: false,
})
export class AgGridTable {
  private gridApi: GridApi | null = null;
  @Prop({mutable : true}) agentData: any = null;
  @State() datalakeLists: any = {};
  @State() rowData: any[] = []
  @State() error: string | null = null;

  @Element() el: HTMLElement;

  private gridDiv: HTMLElement;
  private grid: any; // Will hold the grid instance

  @Watch('agentData')
  async refreshData(): Promise<void> {
    await this.getDataLakeObjects();
    if (this.gridApi) {
      this.gridApi.sizeColumnsToFit();
    }
  }


  private columnDefs: ColDef[] = [
    { field: 'id', headerName: 'ID', sortable: true, filter: true },
    { field: 'name', headerName: 'Name', sortable: true, filter: true },
    { field: 'securityProfile', headerName: 'Security Profile', sortable: true, filter: true },
    { field: 'onboardingStatus', headerName: 'Onboarding Status', sortable: true, filter: true },
    { field: 'createdAt', headerName: 'Created At', sortable: true, filter: true },
    { field: 'updatedAt', headerName: 'Updated At', sortable: true, filter: true },
  ];

  private gridOptions: GridOptions = {
    rowData: this.rowData,
    defaultColDef: {
      flex: 1,
      minWidth: 100,
      resizable: true,
    },
    columnDefs: this.columnDefs,
    rowSelection: 'single',
    animateRows: true,
    suppressCellFocus: true,
    loading: false,
    onGridReady: params => {
      this.gridApi = params.api;
      this.gridApi.sizeColumnsToFit();
    },
  };

  // private deleteObject(path: string) {
  //   console.log('Delete object:', path);
  // }


  // Refresh the grid data
  // private async refreshData(): Promise<void> {
  //   await this.getDataLakeObjects();
  //   if (this.gridApi) {
  //     this.gridApi.sizeColumnsToFit();
  //   }
  // }
  // Lifecycle method: Called after the component is loaded
  componentDidLoad() {
    this.initializeGrid();
    this.getDataLakeObjects();
  }

  // Cleanup when the component is removed
  disconnectedCallback() {
    if (this.grid && this.gridApi) {
      this.grid.destroy();
      this.grid = null;
      this.gridApi.destroy();
    }
  }
  // Initialize the grid
  private initializeGrid(): void {
    if (this.gridDiv && !this.grid) {
      // Create the grid
      this.grid = createGrid(this.gridDiv, this.gridOptions);

      // Set initial data if available
      if (this.rowData.length > 0) {
        const transaction: RowDataTransaction = {
          add: this.rowData,
          addIndex: 0,
        };
        if (this.gridApi) {
          this.gridApi.applyTransaction(transaction);
        }
      }
    }
  }

  async getDataLakeObjects() {
    const oThis = this;
    oThis.rowData = [];
    try {
      oThis.error = null;
      // const token = 'q'

      // const response = await fetch('https://cloud.eu1.sws.siemens.com/api/agentmanager-xdoipreprod/v1-earlyaccess/agents', {
      //   headers: {
      //     Authorization: `Bearer ${token}`,
      //     'Content-Type': 'application/json',
      //   },
      // });

      // if (!response.ok) {
      //   throw new Error(`HTTP error! status: ${response.status}`);
      // }

      // const agentData = await response.json();

      // Map the response to match the column definitions
      oThis.rowData = this.agentData?.data?.map((item: any) => ({
        id: item.id,
        name: item.name,
        securityProfile: item.securityProfile,
        onboardingStatus: item.onboardingStatus,
        createdAt: item.createdAt,
        updatedAt: item.updatedAt,
      }));

      console.log('getDataLakeObjects', oThis.rowData);

      // Update the grid with the new data
      const transaction: RowDataTransaction = {
        add: oThis.rowData,
        addIndex: 0,
      };

      if (this.gridApi) {
        this.gridApi.applyTransaction(transaction);
      }

    } catch (error) {
      oThis.error = error.message || 'An error occurred while object/folders list';
    } finally {
      // oThis.gridApi.setGridOption("loading", false);
    }
  }

  render() {
    return (
      <div class="datalake-grid-container">
        <div class="grid-header">
         
          {/* <ix-button onClick={() => this.refreshData()}>Reload</ix-button> */}
        </div>
        {this.error && (
          <div class="error-message">
            <ix-typography class="error-message">{this.error}</ix-typography>
          </div>
        )}
        <div class="grid-wrapper ag-theme-alpine-dark ag-theme-ix">
          <div ref={el => (this.gridDiv = el as HTMLElement)} class="ag-theme-alpine-dark ag-theme-ix" style={{ height: '300px', width: '100%' }} />
        </div>
      </div>
    );
  }
}
